import { render, staticRenderFns } from "./Powder.vue?vue&type=template&id=222005cc&scoped=true&"
import script from "./Powder.vue?vue&type=script&lang=js&"
export * from "./Powder.vue?vue&type=script&lang=js&"
import style0 from "./Powder.vue?vue&type=style&index=0&id=222005cc&prod&lang=scss&scoped=true&"
import style1 from "./Powder.vue?vue&type=style&index=1&id=222005cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222005cc",
  null
  
)

export default component.exports